import Alert from "react-bootstrap/Alert";
import React from "react";

export default class InfoBac extends React.Component{
  render() {
    return(
      <Alert variant="info">
        <ul>
          <li>
            Si el beneficiario no se encuentra en el listado, por favor comuníquese a la línea de
            Audioservicios Colsubsidio (601) 7457900 opciones 2-5-2 o acérquese al centro de Servicios
            más cercano.
          </li>
          <li>
            Respetado usuario, si dentro de su grupo familiar algún beneficiario tiene la
            afiliación con estado no vigente, y lo inscribe, puede acceder al servicio educativo
            bajo la tarifa de no afiliado.
          </li>

        </ul>
      </Alert>
    )
  }
}
